var _g, _circle, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlags(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8673_70384)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70,
    r: 70,
    fill: "#FFCC1D"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70,
    r: 67,
    stroke: "#F1C220",
    strokeWidth: 6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8673_70384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7933 79.4918C32.368 80.4927 33.3348 81.2293 34.4515 81.514C34.7976 81.6026 35.1455 81.6452 35.4916 81.6452C36.2146 81.6452 36.9205 81.4441 37.5547 81.0723L37.5581 81.0773C37.8208 80.9461 44.0595 77.8106 48.4943 71.1762C52.1824 65.6553 60.9515 63.7764 65.0504 63.1847L67.55 67.5156L52.9907 92.7401C52.2847 93.9642 52.7025 95.5278 53.9268 96.2337C54.329 96.4656 54.7691 96.5765 55.2038 96.5765C56.0853 96.5765 56.9464 96.1162 57.4203 95.2977L70.5031 72.6326L83.5859 95.2977C84.0583 96.1178 84.9195 96.5765 85.8026 96.5765C86.2373 96.5765 86.6772 96.4656 87.0797 96.2337C88.3039 95.5278 88.7217 93.9642 88.0158 92.7401L73.4564 67.519L75.9561 63.1865C80.0549 63.7781 88.824 65.6571 92.5121 71.178C96.9451 77.8124 103.184 80.9497 103.446 81.0791L103.45 81.0741C104.086 81.4457 104.79 81.647 105.513 81.647C105.859 81.647 106.209 81.6044 106.555 81.5158C107.668 81.231 108.639 80.4943 109.211 79.4935L116.657 66.426C117.346 65.2222 117.211 64.2521 116.978 63.6519C116.611 62.721 115.742 61.9997 114.526 61.6196C110.913 60.4907 106.717 58.7738 102.979 54.5829L102.343 55.1506L102.935 54.5351C102.512 54.1293 93.409 45.5036 85.2964 45.0313C85.0917 44.5181 84.7303 44.0645 84.2137 43.7662C82.9859 43.0621 81.4242 43.4798 80.7182 44.7023L70.5015 62.4057L60.2832 44.7023C59.5773 43.478 58.0121 43.0621 56.7895 43.7662C56.2745 44.0629 55.9113 44.5165 55.7068 45.0279C47.5976 45.4932 38.491 54.1293 38.0663 54.5351L38.6579 55.1506L38.0219 54.5829C34.2844 58.7738 30.0884 60.4927 26.477 61.6196C25.2613 61.9997 24.3899 62.721 24.0251 63.6519C23.7881 64.2521 23.6535 65.2222 24.3457 66.426L31.7933 79.4918ZM99.7805 59.4234L96.4744 65.1505C98.1061 68.2351 100.3 70.7584 102.616 72.7671L105.92 67.0415C103.671 64.9801 101.552 62.4531 99.8879 59.4063L101.903 55.9143C104.251 58.4873 106.742 60.1667 109.168 61.3517L105.905 67.0006C108.365 68.7142 110.698 69.8924 112.314 70.6069L109.16 76.1413C107.702 75.5652 105.298 74.4891 102.58 72.7806L100.203 76.9002C98.2391 75.3605 95.8844 73.149 93.9321 70.2301C93.8553 70.1156 93.7649 70.0153 93.6848 69.9044L96.4384 65.1372C96.4248 65.0997 96.4077 65.0655 96.3958 65.0297C95.054 61.0449 91.6439 58.7603 87.637 57.4779L90.0174 53.3585C93.8638 54.4479 97.4155 56.3184 99.7805 59.4234ZM85.1511 47.256C85.2483 47.0873 85.3216 46.9099 85.3745 46.7309C87.7087 46.9049 90.1777 47.8358 92.4777 49.0565L90.1026 53.1691C87.1683 52.9184 84.8376 51.73 82.8937 51.1673L85.1511 47.256ZM80.1792 55.8717C82.3447 56.3184 84.539 57.3893 87.2517 57.8582L84.065 63.3807C81.3947 62.431 78.7877 61.8888 76.8781 61.5887L80.1792 55.8717ZM60.8286 55.8717L64.1296 61.5871C62.2199 61.8872 59.6147 62.4294 56.9428 63.3791L53.7543 57.8582C56.4671 57.3893 58.6631 56.3184 60.8286 55.8717ZM55.6315 46.7327C55.6861 46.9117 55.7578 47.0873 55.8566 47.2578L58.1141 51.1693C56.1686 51.7336 53.8378 52.922 50.9034 53.1709L48.5284 49.0585C50.8285 47.8358 53.2991 46.9049 55.6315 46.7327ZM31.8393 61.3534C34.2655 60.1683 36.7549 58.4889 39.1028 55.9159L41.1182 59.4079C39.4557 62.453 37.3347 64.9799 35.0874 67.0431L38.3935 72.7687C40.7074 70.76 42.9018 68.2367 44.535 65.1522L41.2273 59.4248C43.594 56.32 47.1454 54.4495 50.9938 53.3599L53.3742 57.4793C49.3691 58.7599 45.959 61.0445 44.6171 65.0311C44.6033 65.0685 44.5846 65.1026 44.5727 65.1384L47.3262 69.9058C47.2478 70.0167 47.1558 70.1189 47.0789 70.2314C45.1285 73.1504 42.7754 75.3619 40.8077 76.9016L38.4293 72.782C35.7098 74.4905 33.3073 75.5665 31.8495 76.1443L28.6953 70.6079C30.3116 69.8953 32.6424 68.7172 35.1045 67.0019L31.8393 61.3534Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8673_70384",
    x: 0.5,
    y: 0,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8673_70384"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8673_70384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.3333,
    height: 93.3333,
    fill: "white",
    transform: "translate(23.8334 23.334)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlags);
export default __webpack_public_path__ + "static/media/flags.fc3ebddea9b6c5a41baaffeeedd035cc.svg";
export { ForwardRef as ReactComponent };